import React from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../features/attackSurface/assets/deepkeep-logo-colorful.svg';
import './Header.css';

interface HeaderProps {
  showContactButton?: boolean;
}

const Header: React.FC<HeaderProps> = ({ showContactButton = true }) => {
  const navigate = useNavigate();

  const handleContactUs = () => {
    navigate('/contact');
  };

  const handleLogoClick = () => {
    navigate('/');
  };

  return (
    <header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0', padding: '0rem 0' }}>
      <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={handleLogoClick}>
        <img 
          src={logo}
          alt="DeepKeep Logo"
          style={{ width: '60%', height: '60%'}} 
        />
      </div>
      {showContactButton && (
        <button
          onClick={handleContactUs}
          className='contact-us-button'
        >
          Contact Us
        </button>
      )}
    </header>
  );
};

export default Header;